import { useAppDispatch, useAppSelector } from 'app/hooks'
import { UIAction } from 'app/slices/UI'
import DialogNotice from './DialogNotice'

export default function GlobalDialog() {
  const dispatch = useAppDispatch()
  // const dialogName = useAppSelector((s) => s.UI.dialogName)
  const notice = useAppSelector((s) => s.UI.notice)
  return (
    <>
      <DialogNotice
        open={!!notice}
        handleClose={() => {
          dispatch(UIAction.setNotice(''))
        }}
      >
        {notice}
      </DialogNotice>
    </>
  )
}
